import * as loaderActions from "./LoaderActions";
import * as userActions from "./UserActions";
import * as errorActions from "./ErrorActions";
import * as leadGenActions from "./LeadGenActions";
import * as personalizedActions from "./PersonalizedActions";
import * as adtActions from "./ADTActions";
import * as clinicActions from "./ClinicActions";
import * as platformCoreActions from "./PlatformCoreActions";
import * as payersAndMeasuresActions from "./PayersAndMeasuresActions";
import * as helpCenterActions from "./HelpCenterActions"
import * as patient360Actions from "./Patient360Actions";
import * as patientTrialActions from "./PatientTrialActions";
import * as smartSchedulerActions from "./SmartSchedulerActions";
import * as nlpActions from "./NLPActions";
const onClinicChange = (clinicId)=> async dispatch =>{
  dispatch(patient360Actions.resetData());
  dispatch(patientTrialActions.resetData());
  dispatch(clinicActions.setClinicUsers([]));
}
export { 
  loaderActions,
  userActions,  
  errorActions,
  leadGenActions,  
  personalizedActions,
  adtActions,
  clinicActions,
  platformCoreActions,
  payersAndMeasuresActions,
  helpCenterActions,
  patient360Actions,
  patientTrialActions,
  smartSchedulerActions,
  nlpActions,
  onClinicChange
};
